import { render, staticRenderFns } from "./DlgInfoHistoryDisable.vue?vue&type=template&id=c36be10a&scoped=true"
import script from "./DlgInfoHistoryDisable.vue?vue&type=script&lang=js"
export * from "./DlgInfoHistoryDisable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36be10a",
  null
  
)

export default component.exports